import "./About.scss";

import Me from "../../assets/me.png";
import { ReactComponent as Open } from "../../assets/open.svg";

function About({ onRequestContact }) {
  return (
    <div className="about">
      <div className="container">
        <div className="photo-links">
          <img src={Me} alt="A simple selfie" />
          <div className="links">
            <a href="https://www.leofrati.fr/" target="_blank" rel="noreferrer">
              My portfolio
              <Open />
            </a>
            <a href="https://www.instagram.com/oelfrt/" target="_blank" rel="noreferrer">
              Instagram
              <Open />
            </a>
            <a href="https://www.linkedin.com/in/leofrati/" target="_blank" rel="noreferrer">
              Linkedin <Open />
            </a>
          </div>
        </div>
        <div className="content">
          <p>I’m Leo, a french designer based in Bordeaux 🍷.</p>
          <p>
            {" "}
            I built Flowcam because i was upset by how simple camera with no over-processing kept
            disappearing or locking their features behind a paywall (hi zerocam).
          </p>
          <p>
            {" "}
            I wanted a minimal app that wouldn’t overprocess or overshapen my photos, but instead
            just let me snap honest, natural shots.
          </p>
          <p> Flowcam is my way to keep things simple.</p>
          <p>
            {" "}
            If you have any feedback or spot something weird,{" "}
            <span
              onClick={(e) => {
                e.preventDefault();
                onRequestContact();
              }}
            >
              please reach out
            </span>
            . I’d love to keep improving Flowcam together.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
